<template>
  <div class="loadmore-tips loadmore-tips-wrap" id="loadMore">
    <span class="loadmore-tips loadmore-tips-circle" :style="circleFm"></span>
    <span class="loadmore-tips loadmore-tips-circle" :style="circleFm"></span>
    <span class="loadmore-tips loadmore-tips-circle" :style="circleFm"></span>
  </div>
</template>

<script>
export default {
  props: ['circleFm']
}
</script>

<style lang="scss" scoped>
.loadmore-tips.loadmore-tips-wrap {
  padding: 10px 0;
  text-align: center;
}

.loadmore-tips.loadmore-tips-wrap > span {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #3aa8e8;
  -webkit-animation: loadmoreScale 1s infinite ease-in-out;
  animation: loadmoreScale 1s infinite ease-in-out;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.loadmore-tips.loadmore-tips-wrap > span:nth-child(1) {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.loadmore-tips.loadmore-tips-wrap > span:nth-child(2) {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@keyframes loadmoreScale {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// AnimationLoadmore.vue?0da6facc